export const inputTypes = {
    1: {nome: 'Simple Text input', type: 'input'},
    2: {nome: 'Large Text input', type: 'textarea'},
    3: {nome: 'Select menu', type: 'select'},
    4: {nome: 'Option menu', type: 'option'},
    5: {nome: 'Checkbox', type: 'checkbox'}
}
